let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7dD9P")).then(() => parcelRequire('8Giki'));